import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const TsPromoTextIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="40 20 64 64" innerRef={ref}>
      <rect x="40" y="20" width="64" height="64" rx="8" fill="#5667F6"/>
      <path d="M50 57V52H67.1111V57H50ZM50 47V42H76.8889V47H50ZM50 37V32H76.8889V37H50ZM72 72V64.3125L85.5056 50.5625C85.8722 50.1875 86.2796 49.9167 86.7278 49.75C87.1759 49.5833 87.6241 49.5 88.0722 49.5C88.5611 49.5 89.0296 49.5938 89.4778 49.7812C89.9259 49.9688 90.3333 50.25 90.7 50.625L92.9611 52.9375C93.287 53.3125 93.5417 53.7292 93.725 54.1875C93.9083 54.6458 94 55.1042 94 55.5625C94 56.0208 93.9185 56.4896 93.7556 56.9688C93.5926 57.4479 93.3278 57.875 92.9611 58.25L79.5167 72H72ZM75.6667 68.25H77.9889L85.3833 60.625L84.2833 59.4375L83.1222 58.3125L75.6667 65.875V68.25ZM84.2833 59.4375L83.1222 58.3125L85.3833 60.625L84.2833 59.4375Z" fill="#F8F8F8"/>
    </SvgIcon>
  );
})

export default TsPromoTextIcon;